import * as React from 'react'
import { FC, useState } from 'react'
import Tabs from '@organisms/Tabs'
import ContentBlock from '@organisms/ContentBlock'
import useMe from '@hooks/useMe'
import { Wrapper } from './styled'
import EditFilialBlock from './EditFilialBlock'

const FilialSettings: FC = () => {
  const { companyBranch } = useMe()

  const [active, setActive] = useState(0)

  if (!companyBranch) {
    return null
  }

  return (
    <Wrapper>
      <Tabs
        active={active}
        setActive={setActive}
        tabSize="big"
        items={[
          {
            id: '1',
            title: 'Настройки филиала',
            children: (
              <ContentBlock>
                <EditFilialBlock filialInfo={companyBranch} />
              </ContentBlock>
            ),
          },
        ]}
      />
    </Wrapper>
  )
}

export default FilialSettings
